import React, { Fragment, useEffect, useState } from "react";
import { Footer } from "../footer";
import { AthleteHeader } from "./athleteheader";
import { Col, Modal, Row } from "react-bootstrap";
import { galdelete, gallerycreate, gallist } from "../../../services/login";
import { toast } from "react-toastify";
import ImageURL from "../../../imageurl";
import Swal from "sweetalert2";

export const AddGallery = () => {
  const [show, setShow] = useState(false);
  const handleshow = () => {
    setShow(true);
    setErrorMsg([]);
    setPhoto([]);
  };

  const handleclose = () => {
    setShow(false);
    setErrorMsg([]);
    setPhoto([]);
  };

  let arr = [];
  let arr1 = [];
  const [errorMsg, setErrorMsg] = useState([]);
  const [photo, setPhoto] = useState([]);
  function photofile(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      if (event.target.files.length !== 0) {
        if (event.target.files[i].name.match(/\.(jpg|jpeg|png)$/i)) {
          var size = event.target.files[i].size / 1024 / 1024;
          if (size > 50) {
            arr1.push(
              event.target.files[i].name + " size should be less than 50MB"
            );
            setErrorMsg([...arr1]);
          } else {
            arr.push(event.target.files[i]);
          }
        } else {
          arr1.push(
            event.target.files[i].name + " should be jpg or jpeg or png format"
          );
        }
      }
    }
    setPhoto(arr);
    setPhoto([...photo, ...arr]);
    setErrorMsg(arr1);
    setErrorMsg([...errorMsg, ...arr1]);
  }

  function submitphoto(e) {
    e.preventDefault();
    setErrorMsg([]);
    if (photo.length > 0) {
      const temp = new FormData();
      temp.append("image_count", photo.length);
      temp.append("category", 0);
      for (let i = 0; i < photo.length; i++) {
        temp.append("photo_" + [i + 1], photo[i]);
        temp.append("desc_" + [i + 1], "");
        console.log("photo_" + [i + 1], photo[i], "desc_" + [i + 1], "");
      }
      gallerycreate(temp).then((res) => {
        if (res.status === true) {
          handleclose();
          toast.success(res.message);
          listall();
        } else {
          toast.error(res.message);
        }
      });
    } else {
      setErrorMsg(["Please Select Photo"]);
    }
  }

  const [glist, setGList] = useState([]);
  const [gpath, setGPath] = useState("");
  useEffect(() => {
    listall();
  }, []);

  function listall(){
    gallist().then((res) => {
      if (res.status === true) {
        setGList(res.data.details);
        setGPath(ImageURL + res.data.path);
      }
    });
  }

  function deletegallery(did){
    Swal.fire({
      title: "Are you sure want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#4ecc48",
      cancelButtonColor: "#ac0404",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        galdelete(did).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            listall();
          }
        })
      }
    });

    
  }
  return (
    <Fragment>
      <AthleteHeader />
      <div id="content-page" className="content-page">
        <div className="container-fluid">
          <h4>Gallery</h4>
          <div className="card mt-2">
            <div className="card-body">
              <div align="right">
                <a className="btn btn-primary" onClick={() => handleshow()}>
                  <i className="las la-plus fa-lg"></i> Add Photos
                </a>
              </div>
              <div className="row mt-2" id="gallery-pic">
                {glist.length === 0 && (
                  <div className="col-md-12">
                    <h4 className="text-danger">
                      {" "}
                      Photos will be updated soon
                    </h4>
                  </div>
                )}
                {glist.length !== 0 && (
                  <>
                    {glist.map((data, i) => {
                      return (
                        <div className="col-md-2 mt-4" key={i}>
                          <a className="photo-mark" onClick={() => deletegallery(data.id)}>
                            <i className="las la-trash fa-lg"></i>
                          </a>
                          <img
                            src={gpath + data.photo}
                            className="photoimg"
                            height="100px"
                          />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} size="lg">
        <Modal.Header>
          <h4>Add Photos</h4>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Photos <span className="text-danger"> *</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  accept=".jpg,.png,.jpeg"
                  multiple
                  onChange={photofile}
                />
                {photo.map((data, i) => {
                  return <li key={i}>{data.name}</li>;
                })}
              </div>
            </Col>
            {errorMsg.map((data, i) => {
              return (
                <span className="text-danger" key={i}>
                  {data}
                </span>
              );
            })}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a className="btn btn-danger" onClick={handleclose}>
            Close
          </a>

          <a className="btn btn-success" onClick={submitphoto}>
            Submit
          </a>
        </Modal.Footer>
      </Modal>
      <Footer />
    </Fragment>
  );
};
